import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { RightArrowBigIcon } from '../../icon/icon';

interface SubContractResponse {
  subcontractId: number;
  target: string;
  state: string;
  createdAt: string;
}

interface JobSearchProps {
  items: SubContractResponse[];
  registClick?: () => void;
}

interface LocationState {
  state?: {
    auth: string;
  };
}

export const JobSearchSection = ({ items, registClick }: JobSearchProps) => {
  const { state } = useLocation() as LocationState;
  return (
    <ContractWrap>
      <ul>
        {items && items.length > 0 ? (
          items.map((item, i) => (
            <li key={i}>
              <Link
                to={{
                  pathname: `/working/detail/${item.subcontractId}`,
                  state: {
                    borderLine: true,
                    auth: state?.auth,
                  },
                }}
              >
                <div>
                  <TypeBadge className="type" orderStatus={item.state}>
                    {item.state}
                  </TypeBadge>
                  <span className="label">도착날짜</span>
                  <span className="date">{item.target}</span>
                </div>
                <div className="icon-box">
                  <RightArrowBigIcon />
                </div>
              </Link>
            </li>
          ))
        ) : (
          <div className="no-data">검색 결과가 없습니다.</div>
        )}
      </ul>
      {state?.auth === 'manager' ? null : (
        <BtnBox>
          <button className="second-btn" onClick={registClick}>
            등록하기
          </button>
        </BtnBox>
      )}
    </ContractWrap>
  );
};

// style
const ContractWrap = styled.section`
  background-color: ${(props) => props.theme.textWhiteColor};
  border-radius: 1.6rem;
  box-shadow: 0 2px 5px 3px rgba(0, 0, 0, 0.05);
  padding: 1.5rem 0 8.6rem;
  position: relative;
  overflow: hidden;
  height: 90%;
  ul {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }
    li {
      a {
        padding: 1rem 1.2rem 1rem 2rem;
        display: flex;
        width: 100%;
        justify-content: space-between;
        .label {
          margin: 0 1.2rem 0 0.8rem;
          font-size: 1.2rem;
          font-weight: 600;
          color: ${(props) => props.theme.textAAAColor};
        }
        .date {
          font-size: 1.3rem;
          font-weight: 600;
        }
      }
    }
  }
`;

const TypeBadge = styled.span<{ orderStatus: string }>`
  min-width: 5.2rem;
  font-size: 1.1rem;
  padding: 0 0.5rem;
  font-weight: 600;
  border-radius: 1.1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 2.2rem;
  background-color: ${(props) =>
    props.orderStatus === '수주 됨' ? '#437BE6' : '#DEDEDE'};
  color: ${(props) => props.theme.textWhiteColor};
`;

const BtnBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.textWhiteColor};
  padding: 1.5rem 1.3rem;
  position: absolute;
  left: 0;
  bottom: 0;
  button {
    width: 100%;
    border-radius: 1.2rem;
    border: 0;
    outline: none;
    font-size: 1.8rem;
    font-weight: 600;
    padding: 1.7rem 1rem;
    height: 5.6rem;
  }
  .first-btn {
    background-color: ${(props) => props.theme.textWhiteColor};
    color: ${(props) => props.theme.btnBlueColor};
    border: 1px solid ${(props) => props.theme.btnBlueColor};
  }
  .second-btn {
    background-color: ${(props) => props.theme.btnBlueColor};
    color: ${(props) => props.theme.textWhiteColor};
  }
`;
